import React from 'react';
import { getBrandConfig } from '../brand-config';
import BrandHeader from '../components/BrandHeader';

interface AppPlaceholderProps {
  appName: string;
}

function AppPlaceholder({ appName }: AppPlaceholderProps) {
  const brandConfig = getBrandConfig();

  return (
    <div className="app" style={{ '--primary-color': brandConfig.primaryColor } as React.CSSProperties}>
      <BrandHeader />

      <main className="main-content">
        <div className="placeholder-content">
          <div className="placeholder-icon">🚧</div>
          <h2>{appName}</h2>
          <p>This application is currently under development.</p>
          
          <div className="placeholder-actions">
            <a href="/" className="btn-secondary">
              ← Back to {brandConfig.name} Apps
            </a>
            <a href="https://automations.easystreetbrands.com" className="portal-cta-btn">
              Go to Automation Portal
            </a>
          </div>

          <div className="app-info">
            <h3>About this Application</h3>
            <p>
              The {appName} for {brandConfig.name} will provide powerful tools to help manage and grow the brand. 
              Check back soon or visit the main portal for other available applications.
            </p>
          </div>
        </div>
      </main>

      <footer className="footer">
        <p>&copy; 2024 {brandConfig.name}. Internal automation workspace.</p>
      </footer>
    </div>
  );
}

export default AppPlaceholder;
